import { PropTypes } from "prop-types";
import { ALButtonV2 } from "@components/ALComponents";

function Categories({ categories, refine }) {
  return (
    <div>
      <h3 className="typo-h2 font-bold mb-[20px] mobile:mb-[15px]">Top Searches</h3>
      <div className="flex flex-wrap gap-[10px]" data-testid="categories">
        {categories.map((keyword) => (
          <ALButtonV2
            key={keyword}
            size="medium"
            variant="outline"
            onClick={() => refine(keyword)}
            className="min-w-[unset] px-[25px] mobile:px-[20px]"
          >
            {keyword}
          </ALButtonV2>
        ))}
      </div>
    </div>
  );
}

Categories.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string),
  refine: PropTypes.func,
};

export default Categories;
